import { createApiHooks } from '../common';
import {
  updatePreference,
  searchPreferences,
  recoverPreference,
  createPreference,
  deletePreference,
  getPreference
} from './api';

const {
  useGetPreferenceQuery,
  useSearchPreferencesQuery,
  useCreatePreferenceMutation,
  useUpdatePreferenceMutation,
  useDeletePreferenceMutation,
  useRecoverPreferenceMutation
} = createApiHooks({
  name: 'up',
  queries: {
    getPreference,
    searchPreferences
  },
  mutations: {
    createPreference,
    updatePreference,
    deletePreference,
    recoverPreference
  }
});

export {
  useGetPreferenceQuery,
  useSearchPreferencesQuery,
  useCreatePreferenceMutation,
  useUpdatePreferenceMutation,
  useDeletePreferenceMutation,
  useRecoverPreferenceMutation
};
